{
  "table": {
    "client": "Client",
    "workflow": "Flux de travail",
    "section": "Section",
    "step": "Étape",
    "state": "État",
    "started": "Commencé",
    "objectTypes": {
      "ACCOUNT": "Compte",
      "ACCOUNT_GROUP": "Groupe de comptes",
      "GOAL": "Objectif",
      "HOUSEHOLD": "Ménage"
    }
  },
  "title": "Titre",
  "subtitle": "Sous-titre",
  "state": "État",
  "icon": "Icône",
  "applied": "Appliqué",
  "source": "Source",
  "startWorkflow": "Commencer {{workflowName}}",
  "caughtUp": "Vous êtes à jour",
  "caughtUpSubtitle": "Il s'agit maintenant d'une autre personne dans le flux. Revenez plus tard.",
  "closeWorkflow": "Fermer le flux de travail",
  "pasteWarning": "En tant que fonctionnalité bêta, le collage de configurations de flux de travail peut entraîner des problèmes. Veuillez l'utiliser avec précaution et le tester d'abord dans un environnement sécurisé. Les restrictions de profil de rôle ne sont pas prises en charge et seront supprimées lors de l'importation.",
  "workflowUpdated": "Flux de travail mis à jour",
  "workflowIssues": "Flux de travail mis à jour, mais avec des avertissements",
  "roleProfileNotFound": "Un profil de rôle à l'étape {{subStep}}, dans « {{step}} », n'a pas été trouvé dans cette organisation. Toutes les restrictions de profil de rôle ont été supprimées de la configuration dans cette étape.",
  "goalWorkflowNotFound": "Le flux de travail d'objectifs à l'étape {{subStep}}, dans « {{step}} », n'a pas été trouvé dans cette organisation, il a été supprimé de la configuration.",
  "customFieldNotFound": "Le champ personnalisé « {{customField}} » à l'étape {{subStep}}, dans « {{step}} », n'a pas été trouvé dans cette organisation, il a été supprimé de la configuration.",
  "skippable": "Possibilité de sauter",
  "skip": "Sauter",
  "editCode": "Modifier le code",
  "copy": "Copier la configuration de flux de travail",
  "paste": "Coller la configuration de flux de travail",
  "continue": "Continuer",
  "canGoBack": "Peut revenir en arrière",
  "addRoleProfileToWorkflow": "Ajouter un profil de rôle à un flux de travail",
  "completeableBy": "Les rôles peuvent être complétés",
  "update": "Mettre à jour",
  "remove": "Retirer",
  "create": "Créer",
  "add": "Ajouter",
  "workflowName": "Nom du flux de travail",
  "workflowState": "État du flux de travail",
  "trigger": "Déclencher",
  "event": "Événement",
  "createAnotherAccount": "Créer un autre compte",
  "createAnotherGoal": "Créer un autre objectif",
  "workflow": "Flux de travail",
  "section": "Section",
  "step": "Étape",
  "triggerType": {
    "MANUAL": "Manuel",
    "EVENT": "Basé sur les événements"
  },
  "schedule": {
    "ONE_TIME": "Une fois",
    "WEEKLY": "Hebdomadaire",
    "BI_WEEKLY": "Bihebdomadaire",
    "SEMI_MONTHLY": "Bimensuel",
    "MONTHLY": "Mensuel",
    "QUARTERLY": "Trimestriel"
  },
  "eventType": {
    "CREATED": "Client créé",
    "PERSONAL_INFORMATION_UPDATED": "Mise à jour des IIP",
    "SUITABILITY_SCORE_UPDATED": "Mise à jour de la note d'aptitude",
    "SUITABILITY_REVIEW_DUE": "Examen KYC requis",
    "INTEGRATION_FORM_CREATED": "Formulaire généré en externe",
    "ENTITY_INVITED": "Client invité",
    "ACCOUNT_AFFILIATE_UPDATED": "Affilié de compte mis à jour",
    "SCHEDULED_TRANSFER_UPDATED": "Transfert programmé mis à jour",
    "SCHEDULED_TRANSFER_CANCELED": "Transfert programmé annulé"
  },
  "customAttributeLabels": {
    "disabledInfo": "La personnalisation de ces options est définie au niveau de l'organisation. Veuillez ajuster ces paramètres dans le menu Étiquettes d'attributs personnalisés."
  },
  "saveWorkflow": "Sauvegarder le flux de travail",
  "savedWorkflowMessage": "Flux de travail sauvegardé",
  "addStep": "Ajouter une étape",
  "addSection": "Ajouter une section",
  "newSectionName": "Nouvelle Section",
  "name": "Nom",
  "description": "Description",
  "level": "Niveau ",
  "eventTriggerRule": {
    "field": "Champ",
    "comparison": "Comparaison",
    "value": "Valeur",
    "addNewRule": "Ajouter une règle"
  },
  "investmentKnowledge": {
    "NONE": "Aucun",
    "SOME": "En partie",
    "LIMITED": "Limité",
    "EXPERT": "Expert"
  },
  "riskLevels": {
    "LEVEL_1": "Niveau 1",
    "LEVEL_2": "Niveau 2",
    "LEVEL_3": "Niveau 3",
    "LEVEL_4": "Niveau 4",
    "LEVEL_5": "Niveau 5"
  },
  "timeHorizon": {
    "VERY_SHORT_TERM": "Très court terme",
    "SHORT_TERM": "Court terme",
    "MID_TERM": "Moyen terme",
    "LONG_TERM": "Long terme",
    "VERY_LONG_TERM": "Très long terme"
  },
  "household": {
    "create": "Créer un nouveau ménage",
    "createSubmit": "Créer un ménage",
    "join": "Rejoindre un ménage existant",
    "joinSubmit": "Ajouter au ménage",
    "name": "Nom du ménage",
    "relationshipToPrimaryContact": "Lien avec le contact principal",
    "permissions": "Autorisations",
    "feeGrid": "Grille tarifaire",
    "billingSchedule": "Calendrier de facturation"
  },
  "listTileStates": {
    "ENABLED": "Activé",
    "DISABLED": "Désactivé"
  },
  "goals": {
    "goal": "Objectif",
    "type": "Type d'objectif",
    "start": "Commencer",
    "newGoalPrefix": "Nouvel objectif",
    "addGoal": "Ajouter un objectif",
    "createGoals_one": "Créer un objectif {{count}}",
    "createGoals_other": "Créer des objectifs {{count}}",
    "scopeLabel": "S'agit-il d'un objectif individuel ou familial?",
    "scopes": {
      "INDIVIDUAL": "Individu",
      "HOUSEHOLD": "Ménage"
    },
    "selectHousehold": "Sélectionner le ménage",
    "existingGoals": "Objectifs existants",
    "draftGoals": "Objectifs provisoires",
    "riskQuestion1": "Quel est le risque que vous êtes prêt à prendre avec cet objectif?",
    "riskQuestion1Responses": {
      "LEVEL_1": "Je ne veux rien perdre.",
      "LEVEL_3": "Je suis prêt à supporter des pertes à court terme pour un potentiel de rendement modéré.",
      "LEVEL_5": "Je suis prêt à supporter de plus grandes pertes à court terme pour un potentiel de retour le plus élevé."
    },
    "applyPortfolioAtGoal": "Appliquer le portefeuille à l'objectif",
    "portfolioTheme": "Thème de portefeuille",
    "portfolioModel": "Sélectionner un modèle",
    "taxOptimized": "Fiscalité optimisée",
    "taxOptimizedInfo": "Un portefeuille et/ou un objectif d'optimisation fiscale fait référence à l'application de la stratégie de récolte des pertes fiscales (Tax-Loss Harvesting - TLH). Cette stratégie consiste à vendre des titres qui sont tombés en dessous de leur prix d'achat afin de générer des pertes en capital réalisées qui peuvent être utilisées pour réduire l'impôt sur les bénéfices d'investissement en compensant les gains en capital réalisés.",
    "suitability": {
      "info": "Utilisez les scores d'adéquation ci-dessous pour vous aider à sélectionner le niveau de risque optimal pour le portefeuille.",
      "goalSuitabilityScore": "Score d'adéquation de l'objectif",
      "individualSuitabilityScore": "Score d'adéquation de {{name}}"
    },
    "accountLinking": {
      "title": "Lier l'objectif au(x) compte(s)",
      "info": "Cela génère un sous-compte pour définir le thème et le produit de votre portefeuille. Vous pouvez choisir d'effectuer cette étape ultérieurement.",
      "inputLabel": "Compte(s)"
    },
    "details": {
      "type": "Type d'objectif",
      "name": "Nom de l'objectif",
      "scope": "Portée de l'objectif",
      "timeHorizon": "Horizon temporel",
      "targetAmount": "Montant cible",
      "riskTolerance": "Tolérance au risque",
      "portfolioTheme": "Thème de portefeuille",
      "portfolioModel": "Modèle",
      "taxOptimized": "Fiscalité optimisée",
      "accountsLinked": "Comptes liés"
    }
  },
  "relatedEntities": {
    "summaryTable": {
      "name": "Nom",
      "relation": "Relation"
    },
    "formTitle": "Ajouter une relation",
    "noRelations": "Pas de relations",
    "addRelation": "Ajouter une relation",
    "newRelatedEntitySuccess": "Nouvelle relation ajoutée"
  },
  "subAccounts": {
    "summaryTable": {
      "goal": "Objectif",
      "account": "Compte",
      "product": "Thème/produit du portfolio",
      "noSubAccounts": "Aucun sous-compte",
      "productNotSet": "Non défini"
    },
    "suitability": {
      "title": "Score d'adéquation",
      "info": "Utilisez les scores d'adéquation pour vous aider à sélectionner le niveau de risque approprié pour ce sous-compte."
    },
    "formTitle": "Objectif {{goalName}} et compte {{accountName}}",
    "requireIPS": "Demander un énoncé de politique d'investisseur",
    "allowFractionalShares": "Autoriser le fractionnement d'action",
    "allowClientDeposits": "Autoriser les dépôts par le client",
    "linkSubAccount": "Lier un sous-compte",
    "subAccountLiquidated": "Sous-compte liquidé",
    "warningModal": {
      "title": "Portefeuille pour {{numSubAccounts}} sous-compte{{pluralSuffix}} manquant",
      "body": "Vous avez oublié de définir le thème et le produit du portfolio pour le sous-compte {{numSubAccounts}} {{pluralSuffix}}.",
      "cancelButtonLabel": "Annuler",
      "confirmButtonLabel": "Continuer quand même",
      "returnButtonLabel": "Continuer la rédaction"
    }
  },
  "createAccountButtonTitle": "Créer un compte {{number}}",
  "createTransferButtonTitle": "Initier le transfert {{number}}",
  "createTransfersButtonTitle": "Initier les transferts ({{number}})",
  "start": "Commencer",
  "accountType": "Type de compte",
  "accountReviewPanel": {
    "tfsa": "CELI",
    "cash": "Argent",
    "rrsp": "REER",
    "respSingle": "REEE - Individuel",
    "jointRespSingle": "REEE conjoint - Simple",
    "jointRespFamily": "REEE conjoint - Famille",
    "jointCash": "Trésorerie conjointe",
    "respFamily": "REEE - Famille",
    "respAdult": "REEE - Adulte",
    "corporateCash": "Trésorerie d'entreprise",
    "successor": "Successeur:",
    "affiliate": "Affiliation:",
    "legalGuardian": "Tuteur légal:",
    "careGiver": "Aide-soignant:",
    "beneficiary": "Bénéficiaire:",
    "tableItems": {
      "name": "NOM",
      "relationship": "RELATION",
      "allocation": "ALLOCATION"
    },
    "basicCanadaEducationSavingsGrant": "Subvention canadienne de base pour l'épargne-études",
    "additionalCESG": "SCEE supplémentaire",
    "canadaLearningBond": "Bon d'études canadien"
  },
  "goalLinking": {
    "title": "Lier le compte à des objectifs",
    "info": "Cela génère un sous-compte pour définir le thème et le produit de votre portefeuille. Vous pouvez choisir d'effectuer cette étape ultérieurement.",
    "inputLabel": "Objectif(s)",
    "goalsLinked": "Objectifs liés"
  },
  "baseAccountCreation": {
    "addAccount": "Ajouter un compte",
    "addAffiliate": "Ajouter un affilié",
    "affiliationTable": {
      "nameHeader": "Nom",
      "relationHeader": "Relation",
      "typeHeader": "Type",
      "allocationHeader": "Allocation",
      "requiredInfoHeader": "Champs incomplets"
    },
    "incompleteAffiliationWarning": {
      "title": "Création de compte incomplète",
      "bodyText": "Une ou plusieurs affiliations nécessitent des informations supplémentaires avant de pouvoir être connectées à des comptes. Fournissez les informations nécessaires avant de réessayer."
    }
  },
  "corporateCashAccountReivew": {
    "corporationName": "Nom de l'entreprise",
    "affiliates": "Affiliés"
  },
  "corporateCashAccountCreation": {
    "title": "Trésorerie d'entreprise - {{entityName}}",
    "authorizedIndividual": {
      "title": "Ajouter un individu autorisé",
      "inputLabel": "Nom de la personne autorisée"
    },
    "thirdParty": {
      "title": "Ajouter un tiers",
      "inputLabel": "Nom du tiers"
    },
    "trustee": {
      "title": "Ajouter le(s) mandataire(s)",
      "inputLabel": "Nom du fiduciaire"
    },
    "settlor": {
      "title": "Ajouter le(s) constituant(s)",
      "inputLabel": "Nom du constituant"
    },
    "protector": {
      "title": "Ajouter le(s) protecteur(s)",
      "inputLabel": "Nom du protecteur"
    },
    "beneficialOwner": {
      "title": "Ajouter le(s) bénéficiaire(s) effectif(s)",
      "inputLabel": "Nom du bénéficiaire effectif"
    },
    "incompleteAffiliationError": "Erreur lors de l'ajout d'entités incomplètes en tant qu'affiliations"
  },
  "tfsaAccountCreation": {
    "title": "Compte d'épargne libre d'impôt",
    "subtitle": "Vous souhaitez ajouter un successeur ou un bénéficiaire ?",
    "addASuccessor": "Ajouter un successeur",
    "successorName": "Nom du successeur",
    "relationshipToAccountHolder": "Lien avec le titulaire du compte",
    "addBeneficiaries": "Ajouter des bénéficiaires",
    "beneficiaryName": "Nom du bénéficiaire",
    "addAccount": "Ajouter un compte",
    "allocation": "Allocation"
  },
  "fhsaAccountCreation": {
    "title": "Compte d'épargne libre d'impôt pour l'achat d'une première propriété",
    "subtitle": "Vous souhaitez ajouter un successeur ou un bénéficiaire?",
    "addASuccessor": "Ajouter un successeur",
    "successorName": "Nom du successeur",
    "relationshipToAccountHolder": "Lien avec le titulaire du compte",
    "addBeneficiaries": "Ajouter des bénéficiaires",
    "beneficiaryName": "Nom du bénéficiaire",
    "addAccount": "Ajouter un compte",
    "allocation": "Allocation"
  },
  "rrspAccountCreation": {
    "title": "Régime enregistré d'épargne-retraite",
    "relationshipToAccountHolder": "Lien avec le titulaire du compte",
    "addABeneficiary": "Ajouter un bénéficiaire",
    "beneficiaryName": "Nom du bénéficiaire",
    "addAccount": "Ajouter un compte",
    "allocation": "Allocation"
  },
  "relationship": "Relation",
  "jointAccountHolder": {
    "label": "Copropriétaire du compte",
    "subLabel": "Les comptes conjoints doivent avoir un cotitulaire"
  },
  "jointCashCreation": {
    "title": "Trésorerie conjointe",
    "name": "Nom",
    "addAccount": "Ajouter un compte"
  },
  "createAccount": {
    "repCodeLabel": "Code représentant",
    "repCodeRequired": "Veuillez sélectionner un code représentant"
  },
  "respAccountCreation": {
    "respSingleTitle": "Régime enregistré d'épargne-études - simple",
    "jointRespSingleTitle": "Régime enregistré d'épargne-études conjoint - simple",
    "jointRespFamilyTitle": "Régime enregistré d'épargne-études conjoint - Famille",
    "respAdultTitle": "Régime enregistré d'épargne-études - Adulte",
    "respFamilyTitle": "Régime enregistré d'épargne-études - Famille",
    "subtitle": "Souhaitez-vous solliciter l'une des aides publiques suivantes?",
    "basicCanadaEducationSavingsGrant": "Subvention canadienne de base pour l'épargne-études",
    "additionalCESG": "SCEE supplémentaire",
    "canadaLearningBond": "Bon d'études canadien",
    "transferredFromAnotherInstitution": "Transféré d'un autre établissement",
    "transferDialogTitle": "Confirmez votre compte REEE",
    "transferDialogAccountTypeLabel": "Type de compte",
    "createNewAccount": "Créer un nouveau compte",
    "addAnAffiliate": "Ajouter un affilié",
    "respAccountsMustHaveAtLeastOneAffiliate": "Les comptes REEE doivent avoir au moins un affilié",
    "name": "Nom",
    "affiliationType": "Type d'affiliation",
    "relationshipToAccountHolder": "Lien avec le titulaire du compte",
    "allocation": "Allocation",
    "isLegalGuardian": "Le titulaire du compte est-il le tuteur légal du bénéficiaire",
    "isCareGiver": "Le titulaire du compte est-il l'aidant du bénéficiaire",
    "linkGoalTitle": "Lier le compte à un objectif",
    "linkGoalSubtitle": "Cela génère un sous-compte pour définir le thème et le produit de votre portefeuille. Vous pouvez choisir d'effectuer cette étape ultérieurement.",
    "goal": "Objectif",
    "addAccount": "Ajouter un compte",
    "gender": "Genre",
    "respAgeRestrictionError": "Impossible d'ouvrir un compte REEE pour adulte à cause de la restriction d'âge",
    "updateBeneficiaryDobRequired": "Ce compte REEE n'est plus marqué comme transféré d'un autre établissement, ses bénéficiaires doivent donc avoir moins de 21 ans. Veuillez mettre à jour la date de naissance du bénéficiaire à l'étape suivante avant d'ajouter ou de modifier un affilié."
  },
  "customFieldValues": {
    "boolean": {
      "true": "Oui",
      "false": "Non"
    }
  },
  "reviewAccount": {
    "type": "Type",
    "govGrants": "Subventions publiques",
    "affiliates": "Affiliés",
    "accountType": "Type de compte",
    "custodian": "Dépositaire",
    "otherAffiliates": "Autre affilié",
    "repCode": "Code représentant",
    "linkedGoals": "Objectifs liés",
    "deleteAccountConfirmation": {
      "title": "Supprimer {{accountDisplayTitle}} {{accountId}}",
      "bodyText": "Êtes-vous sûr de vouloir supprimer définitivement {{accountDisplayTitle}} se terminant par {{accountId}} ? Cette action ne peut pas être annulée."
    },
    "noWorkflowErrorMessage": "Aucun flux de travail n'a été configuré pour la modification du compte"
  },
  "reviewGoal": {
    "name": "Nom de l'objectif",
    "timeHorizon": "Horizon temporel",
    "riskQuestion": "Niveau de risque",
    "accounts": "Comptes",
    "portfolio": "Portefeuille",
    "goalCard": {
      "type": "Type",
      "time": "Horizon",
      "target": "Cible"
    }
  },
  "sourceOfTransfer": {
    "bankAccount": "Compte bancaire - EFT",
    "externalTransferIn": "Virement externe entrant",
    "transferToSubAccount": "Virement vers un autre portefeuille"
  },
  "externalTransferCreation": {
    "title": "Nouveau transfert externe"
  },
  "transferMethod": "Méthode de transfert",
  "transferMethodOptions": {
    "ALL_IN_CASH": "Toutes les espèces",
    "PARTIAL_CASH": "Encaissements partiels",
    "ALL_IN_KIND": "Tout en nature"
  },
  "transferTypeOptions": {
    "WITHDRAW": "Retrait",
    "DEPOSIT": "Dépôt"
  },
  "addAnotherTransfer": "Ajouter un autre transfert",
  "externalFinancialInstitution": "Institution financière externe",
  "externalAccount": "Numéro de compte externe",
  "amountToTransfer": "Montant à transférer",
  "addTransfer": "Ajouter un transfert",
  "inboundAccount": "Compte entrant",
  "externalTransferReviewPanel": {
    "title": "Virement externe - {{montant}} vers {{accountType}}",
    "institution": "Institution :",
    "account": "Compte:",
    "transferMethod": "Méthode de transfert:"
  },
  "bankAccountTransferCreation": {
    "title": "Transfert d'un nouveau compte bancaire",
    "institutionNumber": "Nº Institution",
    "transitNumber": "Nº Transit",
    "accountNumber": "Compte #",
    "amountToTransfer": "Montant à transférer",
    "makeRecurring": "Rendre récurrent",
    "enterAValidDate": "Veuillez entrer une date valide",
    "transferDelayError": "Veuillez choisir un jour ouvrable valide à partir du {{date}}"
  },
  "bankAccountTransferReviewPanel": {
    "title": "Virement sur compte bancaire - {{amount}} vers {{accountType}}",
    "type": "Type :",
    "deposit": "Dépôt",
    "account": "Compte:",
    "bankAccount": "Compte bancaire:",
    "institutionNumber": "Nº Institution :",
    "accountNumber": "Compte #:",
    "transitNumber": "Nº Transit",
    "recurring": "Récurrent:",
    "frequency": "Fréquence:",
    "startDate": "Date de début:"
  },
  "workflowCancelModal": {
    "title": "Êtes-vous sûr de vouloir annuler ce flux de travail?",
    "bodyText": "Cette action est irréversible.",
    "cleanupError": "Votre flux de travail a été annulé. Toutefois, certaines de vos données n'ont pas pu être supprimées ou annulées. Veuillez vérifier et communiquer avec l'assistance si nécessaire."
  },
  "createAccountForGoal": {
    "createAccountError": "Création du compte impossible. Veuillez réessayer plus tard ou communiquer avec l'assistance.",
    "createSubAccountError": "Création du sous-compte impossible. Veuillez réessayer plus tard ou communiquer avec l'assistance.",
    "duplicateSubAccountWarning": "Un nouveau sous-compte a été créé. Il est possible qu'un sous-compte en double existe et puisse être supprimé en toute sécurité.",
    "numAccountsBadge": "{{numAccounts}} compte(s)",
    "confirmDialog": {
      "createNewAccount": {
        "title": "Créer un nouveau compte",
        "body": "Il existe déjà un ou plusieurs comptes {{accountType}}. Cette action créera un autre compte {{accountType}} distinct."
      },
      "createNewSubAccount": {
        "title": "Créer un sous-compte",
        "body": "Il existe déjà un ou plusieurs comptes {{accountType}}. Cette action ajoutera un sous-compte, ce qui vous permettra d'appliquer différentes stratégies d'investissement au sein d'un même compte."
      },
      "dontShowAgain": "Ne plus afficher ce message"
    },
    "accountCreationMethodChoice": {
      "title": "Le type de compte existe",
      "confirmButtonLabel": "Continuer",
      "body": "Il existe déjà {{numAccounts}} compte(s) {{accountType}} lié(s) à cet objectif. Souhaitez-vous créer un nouveau compte {{accountType}}, ou ajouter un sous-compte au sein du compte existant?",
      "bodyNoNewAccount": "Il existe {{numAccounts}} compte(s) {{accountType}} lié(s) à cet objectif. Veuillez choisir le compte auquel vous souhaiteriez ajouter un sous-compte.",
      "newAccount": "Créer un nouveau compte {{accountType}}",
      "newSubAccount": "Ajouter un sous-compte dans {{accountName}} {{accountId}}"
    }
  },
  "createGoal": {
    "numGoalsBadge": "{{numGoals}} objectif(s)",
    "goalCreationMethodChoice": {
      "title": "Le type d'objectif existe",
      "confirmButtonLabel": "Continuer",
      "body": "Il existe déjà {{numGoals}} objectif(s) {{goalType}}. Souhaitez-vous créer un nouvel objectif {{goalType}} ou réutiliser un objectif existant?",
      "bodyNoNewGoal": "Il existe {{numGoals}} objectif(s) {{goalType}}. Veuillez choisir l'objectif que vous souhaitez utiliser.",
      "existingGoal": "Lier le compte à {{goalName}} ({{marketValue}})",
      "newGoal": "Créer un nouvel objectif {{goalType}}"
    },
    "confirmDialog": {
      "existingGoalConfirmation": {
        "title": "Lier à un objectif existant",
        "bodyText": "Il existe déjà un ou plusieurs objectifs {{goalType}}. Cette action permettra de continuer à utiliser l'objectif {{goalType}}."
      },
      "newGoalConfirmation": {
        "title": "Créer un nouvel objectif",
        "bodyText": "Il existe déjà un ou plusieurs objectifs {{goalType}}. Cette action créera un autre objectif {{goalType}} distinct."
      }
    }
  },
  "depositReview": {
    "fromBankAccount": "Du compte bancaire",
    "toBankAccount": "Vers le compte bancaire",
    "fromSubAccount": "Du portefeuille",
    "toSubAccount": "Vers le portefeuille",
    "depositDisplayTitle": "{{amount}} à {{account}}",
    "unknownDepositType": "Inconnu",
    "toHolding": "Actif",
    "amount": "Montant",
    "reason": "Motif",
    "createDeposit": "Créer un dépôt",
    "createWithdraw": "Créer Retrait",
    "addAnotherDeposit": "Ajouter un autre dépôt",
    "success": "Dépôt créé avec succès",
    "failure": "Erreur lors de la création du dépôt",
    "deny": "Dépôt refusé",
    "withdrawSuccess": "Retrait créé avec succès",
    "amountExceeds": "Ce sera un retrait complet où tous vos fonds seront transférés vers le portefeuille que vous avez choisi.",
    "amountExceedsWithdraw": "Il s'agira d'un retrait total où tous vos fonds seront retirés.",
    "fullTransfer": "Transfert complet",
    "ALL_IN_CASH": "Transfert complet",
    "PARTIAL_CASH": "Transfert partiel",
    "ALL_IN_KIND": "Virement tout en nature",
    "financialInstitution": "Institution financière",
    "accountNumber": "Numéro de compte",
    "accountType": "Type de compte",
    "transferType": "Type de transfert",
    "schedule": "Planification",
    "startsOn": "Commence le",
    "allInCashMessage": "Tous les actifs de votre compte source seront vendus et transférés sous forme de liquidités.",
    "partialCashMessage": "Saisissez le montant des liquidités que vous souhaitez transférer. Tous les actifs restants resteront sur le compte source.",
    "allInKindMessage": "Tous les actifs seront transférés directement sans être vendus (sous leur forme actuelle).",
    "federalTaxWithheld": "Impôt fédéral retenu",
    "stateTaxWithheld": "Impôt d'État retenu",
    "grossAmount": "Montant brut",
    "error": "Impossible de créer votre transfert.",
    "createTransferError": "Impossible de créer votre transfert. {{ message }}",
    "multiDepositDisabledError": "Le dépôt multiple doit être désactivé pour les transferts de dépôt du dépositaire.",
    "continue": "Continuer",
    "updateDeposit": "Mettre à jour le dépôt",
    "updateWithdraw": "Mettre à jour le retrait",
    "fullTransferWithCurrency": "Transfert complet de {{currency}}",
    "scheduledFor": "Prévu pour",
    "couldNotCompleteAllDeposits": "Un ou plusieurs virements n'ont pas pu être effectués, veuillez modifier ou supprimer les virements infructueux pour continuer.",
    "deleteDepositConfirmation": {
      "title": "Supprimer le dépôt de {{depositDisplayTitle}}",
      "bodyText": "Êtes-vous sûr de vouloir supprimer le dépôt de {{depositDisplayTitle}}? Cette action est irréversible."
    },
    "noWorkflowErrorMessage": "Aucun flux de travail n'a été configuré pour la modification du dépôt",
    "depositNotFoundError": "Dépôt introuvable",
    "noDeposits": "Aucun dépôt à examiner",
    "estimatedAmountLabel": "Montant estimé"
  },
  "withdrawReview": {
    "frequency": "Fréquence",
    "startsOn": "Commence le",
    "startDate": "Date de début"
  },
  "personalInformation": {
    "underAgeOfMajorityMessage": "Les clients doivent être âgés d'au minimum {{MINUMUM_AGE}} ans.",
    "futureDateMessage": "La date ne peut pas se situer dans le futur"
  },
  "residencyInformation": {
    "foreignTaxInformation": {
      "error": "Pays et numéro d'identification fiscale requis.",
      "missingCountry": "Numéro d'identification fiscale requis pour {{country}}"
    },
    "taxIdType": "Type d'identification fiscale",
    "allowITIN": "Autoriser le numéro d'identification du contribuable individuel pour les clients individuels",
    "allowITINni": "Autoriser le numéro ITIN pour les clients non individuels",
    "taxIdOnlyApplicableIn": "Cette entrée d'ID d'impôt est uniquement applicable au Canada ou aux États-Unis, consultez les paramètres - organisation - localisation.",
    "taxIdExplanationIndividuals1": "Les clients individuels devront entrer {{type}}",
    "taxIdExplanationIndividuals2": "Les clients individuels devront entrer {{type1}} ou {{type2}}",
    "taxIdExplanationNonIndividuals": "Les clients non individuels devront entrer {{type}}",
    "taxIdExplanationNonIndividuals2": "Les clients non individuels devront entrer {{type1}} ou {{type2}}",
    "taxIdExplanationNonIndividuals3": "Les clients non individuels devront entrer {{type1}}, {{type2}} ou {{type3}}",
    "customTaxIdLabelsEnable": "Étiquettes personnalisées",
    "customTaxIdLabelfor": "Étiquette de champ {{type}}"
  },
  "subStepOptions": {
    "optionTypes": {
      "BASIC_OR_SELECT_FIELD": {
        "isSelectLabel": "Utiliser les sélections",
        "isDefaultSelectLabel": "Utiliser la liste OneVest",
        "valueColLabel": "Correspondant à la valeur"
      },
      "ADDITIONAL_INFO_FIELD": {
        "checkboxLabel": "Informations complémentaires"
      },
      "DEFAULT_VALUE_FIELD": {
        "checkboxLabel": "Valeur par défaut"
      },
      "DISCLAIMER_INFO": {
        "checkboxLabel": "Mention légale"
      },
      "CUSTOM_LABELS_FIELD": {
        "checkboxLabel": "Étiquette personnaliée",
        "mainSwitch": "Changement principal",
        "goalLabel": "Objectif",
        "priceDateLabel": "Date du prix",
        "currencyLabel": "Devise",
        "unitPriceLabel": "Prix unitaire",
        "tenPercentAmountLabel": "Montant libre de 10 % en dollars",
        "backEndFeePercentageLabel": "Pourcentage des frais de sortie",
        "marketValueLabel": "Valeur marchande",
        "grossRedemptionLabel": "Rachat brut",
        "backEndRedemptionFeeLabel": "Frais de rachat de sortie",
        "grossProceedsLabel": "Produit brut",
        "withholdingTaxLabel": "Retenue d'impôt",
        "netAmountLabel": "Montant net"
      }
    },
    "visibility": {
      "label": "Cette étape de flux de travail n'est pas visible pour les clients"
    }
  },
  "updateAccount": {
    "jurisdiction": "Territoire",
    "sourceOfFunds": "Source de fonds",
    "sourceOfFundsOptions": {
      "SELF": "Personnel",
      "SPOUSE": "Époux",
      "USA_EMPLOYMENT_WAGES": " Salaires de l'emploi",
      "USA_INHERITANCE_TRUST": " Héritage/Fiducie",
      "USA_LOTTERY_GAMING": "Loterie/Jeux",
      "USA_RETIREMENT_FUNDS": "Fonds de retrait",
      "USA_INVESTMENTS": "Investissements",
      "USA_SPOUSAL_PARENTAL_SUPPORT": "Aide du conjoint/parent",
      "USA_GIFT": "Cadeau",
      "USA_SAVINGS": "Économies",
      "USA_UNEMPLOYMENT_DISABILITY": " Chômage/Handicap",
      "USA_LEGAL_SETTLEMENT": "Règlement judiciaire",
      "USA_OTHER": "Autre"
    }
  },
  "subAccountTransferCreation": {
    "title": "Nouveau transfert vers le portefeuille existant",
    "from": "Depuis",
    "to": "Vers"
  },
  "subAccountTransferReviewPanel": {
    "title": "Transfert vers le portefeuille existant",
    "fromPortfolio": "Du portefeuille",
    "toPortfolio": "Vers le portefeuille",
    "amount": "Montant"
  },
  "idVerificationSkipDialog": {
    "title": "Confirmez-vous?",
    "content1": "Vous choisissez d'ignorer le processus de vérification d'identité, ce qui signifie que les dépôts ne pourront pas être effectués tant que celui-ci n'est pas terminé. Pour finaliser votre vérification d'identité et commencer à investir, veuillez communiquer avec notre",
    "content2": " équipe d'assistance,",
    "content3": " qui vous aidera à vérifier votre identité.",
    "cancel": "Annuler",
    "continue": "Continuer"
  },
  "value": "Valeur",
  "cancelWorkflow": "Annuler le flux de travail",
  "states": {
    "ACTIVE": "Actif",
    "CANCELED": "Annulé",
    "COMPLETED": "Terminé"
  },
  "depositTypeOptions": {
    "EFT": "Transfert électronique de fonds",
    "INTERNAL_TRANSFER": "Virement interne",
    "EXTERNAL_TRANSFER": "Virement externe"
  },
  "noDepositTypeSelected": "Aucun type de dépôt sélectionné. Veuillez sélectionner un type de dépôt.",
  "noDepositTypeSelectedWarning": "Aucun type de dépôt n'a été sélectionné. Aucun dépôt ne sera créé.",
  "subStepTypes": {
    "ACCOUNTS": "Comptes",
    "ACTION_ACTIVATE_ALL_SUB_ACCOUNTS": "Activer tous les sous-comptes",
    "ACTION_INTEGRATION": "Créer un formulaire d'accord d'intégration",
    "ACTION_NOTIFY": "Notifier",
    "ACTION_UPDATE_USER": "Mettre à jour l'utilisateur",
    "ACTION_UPDATE_ACCOUNT": "Mettre à jour le compte",
    "APPROVAL": "Approbation",
    "ASSIGN_PORTFOLIO_TO_SUB_ACCOUNT": "Affecter le portefeuille au sous-compte",
    "ARCHIVE_OBJECTS": "Archiver les objets",
    "BANK_ACCOUNT_INFORMATION": "Renseignements sur le compte bancaire",
    "CREATE_ACCOUNT_FOR_GOAL": "Créer un compte pour l'objectif",
    "CREATE_ACCOUNT": "Créer un compte",
    "CREATE_GOAL": "Créer un objectif",
    "DEPOSIT_FORM": "Formulaire de dépôt",
    "DEPOSIT_REVIEW": "Examen du dépôt",
    "DEPOSIT_TYPE": "Type de dépôt",
    "DOCUMENTS": "Documents",
    "EDIT_ACCOUNT": "Modifier le compte",
    "EDIT_GOAL": "Modifier l'objectif",
    "EMPLOYMENT_INFORMATION": "Situation professionnelle",
    "FINANCIAL_PROJECTIONS": "Projections financières",
    "GOALS": "Objectifs",
    "GOAL_RISK_QUESTION_1": "Question sur le risque de l'objectif",
    "HOUSEHOLD": "Ménage",
    "INITIALIZE_HOUSEHOLD_MODEL_PORTFOLIO": "Initialiser le portefeuille modèle du ménage",
    "SELECT_HOUSEHOLD_PARENT_MODEL_PORTFOLIO": "Sélectionner le portefeuille modèle parent du ménage",
    "SELECT_MODEL_PORTFOLIO_EDIT_TYPE": "Sélectionner le type de modification du portefeuille modèle",
    "DETACH_MODEL_PORTFOLIO": "Détacher le portefeuille modèle",
    "EDIT_HOUSEHOLD_MODEL_PORTFOLIO_IPS": "Modifier l'énoncé de politique de placement du ménage",
    "ADD_MODEL_PORTFOLIO_SECURITY_ALLOCATIONS": "Modifier les répartitions de titres",
    "REVIEW_ALLOCATIONS": "Examiner les répartitions",
    "REVIEW_IPS_SUMMARY": "Examiner le résumé de l'énoncé de politique de placement",
    "ACTION_TRANSITION_MODEL_CHANGE_PROPOSAL": "Faire passer la proposition de changement de modèle",
    "ID_VERIFICATION": "Vérification de l'identifiant",
    "INCOME_ASSETS_AND_DEBTS": "Revenus, actifs et dettes",
    "INVESTMENT_KNOWLEDGE": "Connaissance en investissement",
    "NON_INDIVIDUAL_INFORMATION": "Renseignements non individuels",
    "NON_INDIVIDUAL_SETUP": "Configuration non individuelle",
    "PERSONAL_INFORMATION": "Renseignements personnels",
    "PERSONS_OF_INTEREST": "Personnes d'intérêt",
    "PROJECTIONS": "Projections",
    "RELATED_ENTITIES": "Entités liées",
    "RELATIONSHIP_INFORMATION": "Renseignements sur les relations",
    "RESIDENCY_INFORMATION": "Renseignements sur la résidence",
    "REVIEW": "Examiner",
    "REVIEW_ACCOUNT": "Vérifier le compte",
    "REVIEW_BANK_ACCOUNT_INFORMATION": "Vérifier les informations du compte bancaire",
    "REVIEW_GOAL": "Vérifier l'objectif",
    "REVIEW_PORTFOLIO_CHANGES": "Vérifier les modifications du portefeuille",
    "RISK_PROFILE": "Profil de risque",
    "RISK_QUESTION_1": "Question 1 concernant le risque",
    "RISK_QUESTION_2": "Question 2 concernant le risque",
    "SUB_ACCOUNTS": "Sous-comptes",
    "TRANSFERS": "Virements",
    "COLLECT_SIGNERS": "Signataires",
    "ACTION_ADD_FORM_DEFINITION": "Définition du formulaire d'ajout d'action - Bêta",
    "PREPARE_FORM_COMPLETIONS": "Préparer le remplissage des formulaires - Bêta",
    "SIGN_FORM_COMPLETIONS": "Signer le remplissage des formulaires - Bêta",
    "MANAGE_FORM_COMPLETIONS": "Gérer le remplissage des formulaires - Bêta",
    "MANAGE_SIGNERS": "Gérer les signataires - Bêta",
    "CREATE_INTEGRATION_FORM_PACK": "Créer le lot de formulaires d'intégration - Bêta",
    "SEND_INTEGRATION_FORM_PACK": "Envoyer le lot de formulaire d'intégration - Bêta",
    "SYNCHRONOUS_INTEGRATION": "Intégration synchrone",
    "REDIRECT_HANDLER": "Gestionnaire de redirection",
    "WITHDRAW_FORM": "Formulaire de retrait",
    "WITHDRAW_REVIEW": "Révision du retrait",
    "USER_VERIFICATION": "Vérification de l'utilisateur",
    "ACTION_AFFILIATE_INVITATION": "Action invitation à devenir affilié",
    "WORKFLOW_REVIEW": "Révision du flux de travail",
    "NET_WORTH": "Valeur nette",
    "CREATE_ACCOUNT_GROUP": "Créer un groupe de comptes",
    "CALCULATOR": "Calculatrice"
  },
  "householdInitializeShells": {
    "noDraftSelected": "Aucun modèle parent n'a encore été sélectionné. Revenez en arrière pour en choisir un avant de continuer.",
    "selectParentModelError": "Impossible de charger le modèle de portefeuille sélectionné. Veuillez réessayer.",
    "initializeButton": "Initialiser",
    "commitError": "Impossible de créer et d'associer le portefeuille modèle. Veuillez réessayer.",
    "commitProposalPending": "Ce ménage a un changement de modèle proposé en attente de signature. Complétez-le ou abandonnez-le avant de modifier le portefeuille modèle.",
    "commitWarning": "Le portefeuille modèle a été créé avec des avertissements.",
    "commitMissingData": "Informations requises manquantes pour l'initialisation. Revenez en arrière et resélectionnez le modèle parent.",
    "commitBlockedAllocations": "Les répartitions ci-dessous doivent être ajustées avant que ce ménage puisse être initialisé.",
    "modelName": {
      "label": "Nom du modèle",
      "helpText": "Le nom de la copie du modèle propre à ce ménage.",
      "copyOf": "Copie de {{modelPortfolioName}}"
    },
    "summary": {
      "title": "Résumé",
      "parentModel": "Modèle parent",
      "tradingProcess": "Processus d'opération"
    }
  },
  "householdModelPortfolioIps": {
    "saveError": "Impossible d'enregistrer l'énoncé de politique de placement. Veuillez réessayer.",
    "applyWarning": "L'énoncé de politique de placement a été enregistré avec des avertissements.",
    "applyMissingData": "Les renseignements nécessaires à la mise à jour du portefeuille modèle sont manquants. Fermez ce flux de travail et relancez-le à partir du ménage.",
    "loadError": "Impossible de charger le portefeuille modèle du ménage. Veuillez réessayer.",
    "missingModel": "Ce ménage n'a aucun portefeuille modèle à modifier. Fermez ce flux de travail et attachez-en un d'abord.",
    "missingHousehold": "Le ménage à modifier est introuvable. Fermez ce flux de travail et relancez-le à partir du ménage.",
    "summaryEmpty": "Aucun détail de politique de placement n'a été saisi pour ce portefeuille modèle.",
    "current": "Actuel",
    "proposed": "Proposé"
  },
  "discardModelChangeProposal": {
    "title": "Abandonner ce changement proposé?",
    "body": "Ce flux de travail a une proposition de changement de modèle ouverte pour le ménage. L'abandonner annule la proposition, y compris toute signature en attente, et ferme ce flux de travail, de sorte que le ménage peut être modifié de nouveau depuis le début. La conserver laisse la proposition ouverte pour signature et le flux de travail disponible pour être poursuivi.",
    "discard": "Abandonner le changement",
    "keep": "La conserver"
  },
  "householdModelPortfolioAllocations": {
    "security": "Titre",
    "assetClass": "Catégorie d'actifs",
    "current": "Actuel",
    "currentPercent": "Actuel (%)",
    "currentValue": "Actuel ($)",
    "proposed": "Proposé",
    "proposedPercent": "Proposé (%)",
    "proposedValue": "Proposé ($)",
    "change": "Changement",
    "total": "Total",
    "newHolding": "Nouveau",
    "removedHolding": "Retiré",
    "onlyChanges": "Afficher uniquement les changements",
    "empty": "Ce portefeuille modèle n'a aucun titre à examiner.",
    "nothingProposed": "Les titres proposés sont vides. Retournez à l'étape des répartitions et ajoutez-en au moins un avant de continuer.",
    "doesNotAddUp": "Les titres proposés ne totalisent pas 100 %. Retournez à l'étape des répartitions et ajustez-les avant de continuer.",
    "groupsDoNotAddUp": "Les titres de chaque catégorie d'actifs doivent totaliser 100 %, et chaque titre doit appartenir à une catégorie. Retournez à l'étape des répartitions et ajustez-les avant de continuer.",
    "groupWeightsDoNotAddUp": "Les pondérations des catégories d'actifs doivent totaliser 100 % avant que ce portefeuille modèle puisse être modifié. Retournez à l'étape des répartitions et définissez-les.",
    "duplicateHolding": "Le même titre figure deux fois dans les titres proposés. Retournez à l'étape des répartitions et supprimez le doublon avant de continuer.",
    "initializeBlocked": {
      "empty": "Ce portefeuille modèle n'a aucun titre. Ajoutez-en au moins un avant d'initialiser.",
      "incompleteHolding": "Une ligne n'a pas de titre. Sélectionnez-en un pour chaque ligne avant d'initialiser.",
      "duplicateHolding": "Le même titre figure deux fois. Supprimez le doublon avant d'initialiser.",
      "doesNotAddUp": "Les titres ne totalisent pas 100 %. Ajustez-les avant d'initialiser.",
      "groupsDoNotAddUp": "Les titres de chaque catégorie d'actifs doivent totaliser 100 %, et chaque titre doit appartenir à une catégorie. Ajustez-les avant d'initialiser.",
      "groupWeightsDoNotAddUp": "Les pondérations des catégories d'actifs doivent totaliser 100 %. Définissez-les avant d'initialiser.",
      "duplicateTaxRank": "Deux titres ont le même rang fiscal. Attribuez à chacun son propre rang avant d'initialiser.",
      "taxRankGaps": "Les rangs fiscaux doivent commencer à 1 et se suivre sans interruption. Ajustez-les avant d'initialiser."
    },
    "missingCurrent": "Ce flux de travail ne sait plus ce que le ménage détient aujourd'hui, ce contre quoi un changement de modèle doit être signé. Fermez ce flux de travail et relancez-le à partir du ménage.",
    "saveError": "Impossible d'enregistrer le changement de modèle proposé. Veuillez réessayer.",
    "submitError": "Impossible d'envoyer le changement de modèle pour signature. Veuillez réessayer.",
    "notEditable": "Ce ménage a déjà un changement de modèle en attente de signature. Complétez-le ou annulez-le avant d'en proposer un autre.",
    "missingData": "Les renseignements nécessaires pour proposer un changement de modèle sont manquants. Fermez ce flux de travail et relancez-le à partir du ménage.",
    "changeCount_one": "{{count}} titre sur {{total}} a été modifié.",
    "changeCount_other": "{{count}} titres sur {{total}} ont été modifiés.",
    "noChanges": "Aucun des titres n'a été modifié.",
    "currentBalance": "Valeur marchande totale",
    "portfolioPercentSubheader": "Portefeuille %",
    "percentageViewPortfolio": "Portefeuille %",
    "percentageViewAssetClass": "Dans la catégorie %",
    "portfolioAllocationSummary": "Répartition du portefeuille"
  },
  "householdDetach": {
    "detachButton": "Détacher",
    "detachError": "Impossible de détacher le portefeuille modèle. Veuillez réessayer.",
    "archiveWarning": "Le portefeuille modèle a été détaché, mais la copie du ménage n'a pas pu être archivée. Elle sera nettoyée lors de la prochaine association d'un portefeuille modèle.",
    "archiveProposalPending": "Le portefeuille modèle a été détaché, mais la copie du ménage n'a pas pu être archivée tant qu'un changement de modèle proposé est en attente de signature. Complétez ou abandonnez ce changement pour la nettoyer.",
    "missingHousehold": "Le ménage à détacher est introuvable. Fermez ce flux de travail et relancez-le à partir du ménage."
  },
  "formArchived": "Formulaire correctement archivé",
  "formReuploaded": "Formulaire téléversé avec succès",
  "formArchiveError": "Erreur lors de l'archivage du formulaire",
  "formReuploadError": "Erreur lors du rechargement du formulaire",
  "formPdfLoadError": "Le PDF n'a pas pu être chargé après le nombre maximum de tentatives",
  "updateBranch": "Mettre à jour la succursale",
  "addCondition": "Ajouter une condition",
  "removeCondition": "Supprimer la condition",
  "deleteBranch": "Supprimer la succursale",
  "sections": "Sections",
  "unsavedChanges": "Modifications non enregistrées",
  "editWorkflow": "Modifier le flux de travail",
  "conditionOn": "Condition basée sur",
  "client": "Client",
  "contextAccount": "Compte en contexte",
  "contextGoal": "Objectif en contexte",
  "contextTransfer": "Virement en contexte",
  "contextHousehold": "Ménage en contexte",
  "user": "Clients",
  "uploadSignedForm": "Importer le formulaire signé ci-dessous",
  "conditionFieldInfo": "Vous pouvez présélectionner n'importe quel objet dans la liste déroulante ou saisir n'importe quelle clé de champ personnalisé",
  "settings": "Paramètres",
  "prepareFormCompletions": {
    "title": "Préparation des lots de formulaires",
    "description": "Tous les formulaires à signer seront préparés. Cette opération peut prendre quelques minutes.",
    "householdPrimaryUserNotFound": "Impossible de trouver l'utilisateur principal de ce ménage."
  },
  "createIntegrationFormPack": {
    "title": "Création du lot de formulaires",
    "description": "Le lot de formulaires à signer sera créé. Cette opération peut prendre quelques minutes."
  },
  "sendIntegrationFormPack": {
    "title": "Envoi des invitations pour le lot de formulaires",
    "description": "Les invitations pour le lot de formulaires seront envoyées à tous les signataires. Cette opération peut prendre quelques minutes."
  },
  "settingsModal": {
    "title": "Paramètres du flux de travail",
    "saveButton": "Enregistrer",
    "displayCloseButton": "Afficher le bouton de fermeture (X) sur les étapes du flux de travail",
    "cancelOnClose": "Après fermeture (X), annuler le flux de travail et supprimer du profil",
    "archiveObjectsOnClose": [
      "Après annulation, archivez les objets suivants qui ont été créés dans le flux de travail (compte, objectif, sous-compte et/ou virement).",
      "Cela ne s'appliquera pas à la modification des objets."
    ],
    "applicableRoleProfiles": "Peut déclencher le flux de travail",
    "applicableRoleProfilesSupport": "Par défaut, tous les profils de rôle peuvent déclencher des flux de travail. Sélectionnez des profils spécifiques pour restreindre l'accès."
  },
  "manageSigners": {
    "manageSigners": "Gérer les signataires",
    "useOrgUser": "Utiliser l'utilisateur de l'organisation",
    "firstName": "Prénom",
    "lastName": "Nom de famille",
    "email": "Courriel",
    "signingOrder": "Ordre de signature",
    "user": "Utilisateur",
    "description": "Chargement des signataires requis.",
    "restrictedByRole": "Restreint selon le rôle",
    "restrictedToRoles": "Limité au(x) rôle(s)"
  },
  "visibility": {
    "label": "Cette action sera visible uniquement pour les utilisateurs disposant des autorisations appropriées"
  },
  "enableCallToActions": "Activer les appels à l'action",
  "callToActions": "Appels à l'action",
  "action": "Action",
  "buttonVariant": "Variante du bouton",
  "buttonColor": "Couleur du bouton",
  "addAction": "Ajouter une action",
  "primary": "Principal",
  "destructive": "Destructeur",
  "filled": "Rempli",
  "tonal": "Tonal",
  "outlined": "Avec contour",
  "text": "Texte",
  "buttonLabel": "Étiquette du bouton",
  "changeToBasicWorkflow": "Passer au flux de travail basique",
  "changeToComplexWorkflow": "Passer au flux de travail complexe",
  "addNewForm": "Ajouter un nouveau formulaire",
  "formDefinition": "Définition du formulaire",
  "prepare": "Préparer",
  "fiscalYearForRecurringContributions": "Les cotisations récurrentes s'appliquent toujours à l'année fiscale en cours. Le système passera automatiquement à la nouvelle année fiscale le 1er janvier. Pour cotiser à une année antérieure (autorisé jusqu'au 15 avril), utilisez plutôt un dépôt unique ou un dépôt à terme.",
  "netWorthDetails": {
    "CASH": "Détails relatifs aux espèces",
    "EXTERNAL_INVESTMENT_ACCOUNT": "Détails des investissements",
    "REAL_ESTATE": "Détails immobiliers",
    "VEHICLES": "Détails des véhicules",
    "VALUABLES": "Détails des objets de valeur",
    "OTHER_ASSET": "Autres détails relatifs aux actifs",
    "OTHER_LIABILITY": "Autres détails relatifs aux passifs",
    "LOANS": "Détails des prêts",
    "MORTGAGE": "Détails du prêt hypothécaire",
    "CREDIT_CARD": "Détails de la carte de crédit",
    "confirmButton": "Confirmer",
    "addMoreButton": "Ajouter plus"
  },
  "incompleteSignerInfo": "Des renseignements incomplets ont été saisis pour un signataire.",
  "unableToRedirectForVerification": "Impossible de rediriger pour la vérification.",
  "exampleData": {
    "assetClasses": {
      "alternativeInvestments": "Stratégie de Gestion Alternative",
      "fixedIncome": "Titres à Revenu Fixe",
      "equities": "Actions de Sociétés Ouvertes",
      "realAssets": "Actifs Réels"
    },
    "testDocument": "Document de test"
  },
  "archiveObjects": {
    "type": "Type",
    "state": "État",
    "name": "Nom",
    "goalName": "Objectif",
    "accountType": "Type de compte",
    "accountId": "ID du compte",
    "amount": "Montant",
    "currency": "Devise",
    "frequency": "Fréquence",
    "startDate": "Date de début",
    "institution": "Institution",
    "transferMethod": "Méthode de transfert",
    "total": "Total : {{count}}",
    "noObjectsToArchive": "Il n'y a pas d'objets créés dans ce flux de travail ou ils ont déjà été archivés, rien à archiver.",
    "archiveObjectsWarning": "Les objets suivants seront archivés :",
    "archivingMessage": "Archivage de {{objects}} créés au cours de ce flux de travail."
  },
  "redirectHandler": {
    "redirecting": "Redirection vers la vérification...",
    "successTitle": "Transfert vérifié avec succès",
    "successSubtitle": "Votre transfert de dépôt a été vérifié et est en cours de traitement.",
    "failureTitle": "La vérification a échoué",
    "failureSubtitle": "La vérification n'a pas pu être complétée.",
    "cancelling": "Échec de la vérification, annulation du transfert...",
    "closedTabTitle": "La vérification n'a pas été complétée",
    "closedTabSubtitle": "La page de vérification a été fermée avant que la vérification ne soit complétée.",
    "retry": "Réessayer la vérification",
    "cancel": "Annuler le transfert",
    "close": "Fermer",
    "cancelSuccess": "Transfert annulé avec succès.",
    "cancelError": "Impossible d'annuler le transfert. Veuillez réessayer."
  },
  "documentsSubStep": {
    "title": "Signez vos documents",
    "subtitle": "Passez en revue les documents et signez-les"
  },
  "assignPortfolioToSubAccountSubStep": {
    "title": "Quel thème correspond le mieux à votre objectif d'investissement?",
    "subtitle": "Veuillez sélectionner votre préférence. Vous pouvez la modifier à tout moment.",
    "skipHouseholdPortfolioError": "Impossible de sauter l'affectation du portefeuille. Veuillez réessayer."
  },
  "createAccountForGoalSubStep": {
    "title": "Avec quel type de compte souhaitez-vous commencer?",
    "subtitle": "Le type de compte que vous sélectionnez peut avoir une incidence sur les impôts que vous payez sur vos rendements de placement."
  },
  "unsignedDocumentsWorkflow": {
    "stepName": "Signer les documents"
  },
  "depositWorkflow": {
    "stepName": "Déposer des fonds",
    "reviewStepName": "Examiner et soumettre",
    "depositType": {
      "title": "Quel type de dépôt souhaitez-vous effectuer?",
      "eft": "Virement de fonds électronique",
      "internalTransfer": "Portefeuille existant",
      "externalTransfer": "Compte externe"
    },
    "depositForm": {
      "title": "Déposer des fonds",
      "from": "De",
      "to": "À",
      "schedule": "Planification",
      "starting": "À partir de",
      "financialInstitution": "Institution financière",
      "accountNumber": "Numéro de compte",
      "accountType": "Type de compte",
      "transferType": "Type de virement",
      "contributionYear": "Année de cotisation",
      "amount": "Montant",
      "manualBankAccountLinking": "Liaison manuelle de compte bancaire",
      "allowDocumentUpload": "Autoriser le téléversement de documents",
      "automatedBankAccountLinking": "Liaison automatisée de compte bancaire"
    },
    "depositReview": {
      "title": "Examiner et soumettre",
      "eftDisclaimer": "Prévoyez que le montant sera retiré de votre compte dans un délai de 1 à 2 jours ouvrables.",
      "internalTransferDisclaimer": "Prévoyez que le montant sera déposé sur votre compte dans un délai de 3 jours ouvrables.",
      "externalTransferDisclaimer": "Vous demandez par la présente le virement de votre compte et de ses placements tels que décrits ci-dessus. Vous comprenez que vous pourriez encourir des frais de virement sortant facturés par votre institution cédante, ainsi que d'autres frais et charges d'application."
    }
  },
  "withdrawWorkflow": {
    "stepName": "Retirer des fonds",
    "reviewStepName": "Examiner et soumettre",
    "withdrawForm": {
      "title": "Retirer des fonds",
      "to": "À",
      "schedule": "Planification",
      "from": "De",
      "amount": "Montant",
      "reason": "Motif"
    },
    "withdrawReview": {
      "title": "Examiner et soumettre"
    }
  },
  "scheduleWithdrawWorkflow": {
    "stepName": "Retirer des fonds",
    "reviewStepName": "Examiner et soumettre",
    "withdrawForm": {
      "title": "Retirer des fonds",
      "to": "À",
      "schedule": "Planification",
      "from": "De",
      "amount": "Montant",
      "reason": "Motif"
    },
    "withdrawReview": {
      "title": "Examiner et soumettre"
    }
  },
  "createGoalWorkflow": {
    "stepName": "Nouvel objectif",
    "createGoal": {
      "title": "Quel est votre nouvel objectif de placement?"
    },
    "timeHorizon": {
      "title": "Quand souhaitez-vous retirer vos fonds?",
      "subtitle": "Supposons que vous ayez atteint votre objectif. Quel horizon temporel correspond le mieux au moment où vous souhaitez accéder à la majorité de vos fonds."
    },
    "targetAmount": {
      "title": "Quel est votre montant cible?",
      "subtitle": "Cela nous aide à recommander les bons objectifs d'épargne pour atteindre votre objectif. Une estimation est suffisante."
    },
    "goalRiskQuestion": {
      "title": "Quel est le risque que vous êtes prêt à prendre avec cet objectif?",
      "subtitle": "Pour cet objectif spécifique, dans quelle mesure cherchez-vous à maximiser la récompense par rapport au risque que vous souhaitez prendre.",
      "level1": "Je ne veux rien perdre.",
      "level3": "Je suis prêt à supporter des pertes à court terme pour un potentiel de rendement modéré.",
      "level5": "Je suis prêt à supporter de plus grandes pertes à court terme pour un potentiel de retour le plus élevé."
    },
    "goalExitedSuccess": "La création de l'objectif a été annulée avec succès.",
    "errorClosingGoal": "Erreur lors de la fermeture de l'objectif."
  },
  "createEntityWorkflow": {
    "stepName": "Créer une entité",
    "typeSelect": {
      "title": "Quel type d'entité souhaitez-vous créer?",
      "individual": "Particulier",
      "nonIndividual": "Non-particulier"
    },
    "nonIndividualTypeSelect": {
      "title": "Quel type d'entité non-particulière souhaitez-vous créer?",
      "publiclyListedEntity": "Entité cotée en bourse",
      "privateCompany": "Société privée",
      "partnership": "Société en nom collectif",
      "soleProprietorship": "Entreprise individuelle",
      "trust": "Fiducie",
      "investmentFund": "Fonds de placement",
      "regulatedEntity": "Entité réglementée",
      "other": "Autre"
    },
    "entityCreation": {
      "title": "Création d'entité",
      "email": "Courriel",
      "firstName": "Prénom",
      "middleName": "Deuxième prénom",
      "lastName": "Nom de famille",
      "entityName": "Nom de l'entité"
    }
  },
  "createSubAccountWorkflow": {
    "stepName": "Nouvel objectif",
    "editAccount": {
      "title": "Saisissez vos informations de compte"
    }
  },
  "createSubAccountFromAccountWorkflow": {
    "stepName": "Nouveau portefeuille",
    "createSubAccount": {
      "title": "Quel est votre objectif de placement?",
      "subtitle": "Sélectionnez un objectif à lier à votre portefeuille."
    }
  },
  "createModelPortfolioWorkflow": {
    "stepName": "Créer un portefeuille modèle",
    "choosePortfolioType": {
      "title": "Comment souhaitez-vous créer votre modèle?",
      "subtitle": "Vous pouvez créer un portefeuille modèle à partir de zéro ou utiliser un modèle préexistant.",
      "fromScratchLabel": "Construire à partir de zéro",
      "fromScratchDescription": "Ajoutez des titres à partir de la gamme de produits et définissez le pourcentage cible et le classement fiscal, le tout à partir de l'interface utilisateur du constructeur de modèles.",
      "fromTemplateLabel": "Créer à partir d'un modèle d'actifs",
      "fromTemplateDescription": "Utilisez un modèle préexistant de différentes allocations d'actifs et attribuez les titres sous-jacents conformément au modèle et à votre stratégie."
    },
    "selectTemplate": {
      "label": "Sélectionner un modèle d'actifs",
      "description": "Créez des modèles uniques à partir d'allocations de catégories d'actifs prédéfinies, offrant à la fois cohérence et flexibilité à vos stratégies.",
      "templateSelectorLabel": "Nom du modèle",
      "assetClassAllocationLabel": "Allocation de catégories d'actifs"
    },
    "createTemplate": {
      "label": "Créer un modèle d'actifs",
      "description": "Créez des modèles uniques à partir d'allocations de catégories d'actifs prédéfinies, offrant à la fois cohérence et flexibilité à vos stratégies.",
      "templateNameLabel": "Nom du modèle",
      "templateDescriptionLabel": "Description du modèle",
      "assetClassLabel": "Catégorie d'actifs",
      "targetLabel": "Cible",
      "buttonSaveForLater": "Enregistrer pour plus tard"
    },
    "addDetails": {
      "title": "Ajouter les détails du modèle",
      "strategyLabel": "Stratégie du modèle",
      "translatedNameLabel": "Nom du modèle",
      "translatedPortfolioDescriptionLabel": "Description du modèle",
      "translatedInvestmentObjectiveLabel": "Objectif d'investissement",
      "riskProfileNameLabel": "Nom du profil de risque",
      "themeIdLabel": "Famille de modèles",
      "suggestableLabel": "Suggérable",
      "zeroPercentCashLabel": "0 % de trésorerie",
      "lowThresholdScoreLabel": "Score seuil le plus bas",
      "suggestedMinScoreLabel": "Score minimum suggéré",
      "suggestedMaxScoreLabel": "Score maximum suggéré",
      "forecastedRateOfReturnLabel": "Taux de rendement prévu",
      "forecastedStandardDeviationLabel": "Écart-type prévu",
      "riskReturnLevelLabel": "Niveau de risque/rendement",
      "urlLabel": "Lien vers les détails fondamentaux",
      "buttonSaveForLater": "Enregistrer pour plus tard",
      "driftSettingsLabel": "Paramètres de dérive"
    },
    "addSecurities": {
      "title": "Ajouter des titres",
      "showSecurityAllocationTableLabel": "Tableau d'allocation des titres",
      "securityAllocationChartLabel": "Graphique d'allocation des titres",
      "columnSecurityLabel": "Titre",
      "columnAssetClassLabel": "Catégorie d'actifs",
      "columnTaxRankLabel": "Rang fiscal",
      "columnTargetPercentageLabel": "% cible",
      "buttonRemoveSecurity": "Retirer",
      "buttonSaveForLater": "Enregistrer pour plus tard",
      "importFromCsv": "Importer à partir d'un fichier CSV",
      "validateSecuritiesLabel": "Valider les titres",
      "validateSecuritiesTitle": "Allocation incomplète",
      "validateSecuritiesBodyText": "Les titres de chaque modèle doivent totaliser 100 %. Bien que vous puissiez finaliser cela plus tard, le modèle ne peut pas être défini comme Actif ou attribué à un portefeuille tant que le total n'est pas correct.",
      "validateSecuritiesCheckboxLabel": "Utiliser l'allocation restante dans de nouveaux ou existants comptes de trésorerie et équivalents"
    },
    "addIps": {
      "title": "Ajouter une déclaration de politique de placement",
      "ipsLabel": "Déclaration de politique de placement",
      "ipsDescriptionLabel": "Description",
      "ipsObjectiveLabel": "Objectif",
      "ipsLiquidityLabel": "Liquidité",
      "disclaimerLabel": "Avis de non-responsabilité",
      "assetClassesDistributionLabel": "Répartition des catégories d'actifs",
      "buttonSaveForLater": "Enregistrer pour plus tard"
    }
  },
  "createAccountGroupWorkflow": {
    "stepName": "Créer un groupe de comptes",
    "createAccountGroup": {
      "title": "Créer un groupe de comptes",
      "subtitle": "Créez un groupe de comptes pour organiser vos comptes"
    }
  },
  "createAssetTemplateWorkflow": {
    "stepName": "Créer un modèle d'actifs",
    "createAssetTemplate": {
      "label": "Créer un modèle d'actifs",
      "description": "Créez des modèles uniques à partir d'allocations de catégories d'actifs prédéfinies, offrant à la fois cohérence et flexibilité à vos stratégies.",
      "templateNameLabel": "Nom du modèle",
      "templateDescriptionLabel": "Description du modèle",
      "assetClassAllocationLabel": "Allocation de catégories d'actifs",
      "assetClassLabel": "Catégorie d'actifs",
      "targetLabel": "Cible",
      "buttonCreate": "Créer"
    }
  },
  "netWorthWorkflow": {
    "stepName": "Ajouter la valeur nette",
    "netWorth": {
      "title": "Comment souhaitez-vous ajouter votre actif ou passif?",
      "subtitle": "Cela nous aidera à comprendre votre situation financière et à vous offrir le meilleur service possible.",
      "automaticLinkTitle": "Connecter automatiquement avec votre compte",
      "automaticLinkSubtitle": "Liez vos comptes bancaires en toute sécurité par l'intermédiaire de notre fournisseur pour synchroniser instantanément vos informations financières.",
      "manualLinkTitle": "Saisir les informations manuellement",
      "manualLinkSubtitle": "Remplissez toutes les informations requises pour saisir et gérer manuellement vos détails financiers."
    }
  },
  "regenerateForms": {
    "button": "Regénérer les formulaires",
    "title": "Regénérer les formulaires",
    "body": "Cela annulera le lot de signatures actuel. Toutes les signatures en attente seront perdues et les signataires devront signer à nouveau. Souhaitez-vous continuer?",
    "confirm": "Annuler le lot et regénérer",
    "cancel": "Conserver les formulaires actuels"
  },
  "calculator": {
    "input": {
      "title": "Entrée de données"
    },
    "amountLabels": {
      "amountRequired": "Montant requis",
      "numberOfShares": "Nombre d'actions"
    },
    "results": {
      "title": "Résultats",
      "positionDetail": "Position actuelle",
      "summary": "Sommaire des rachats",
      "exchangeRate": "Taux de change : 1 CAD = {{rate}} USD",
      "priceDate": "Date aux fins de l'établissement du prix :",
      "currency": "Monnaie de base :",
      "unitPrice": "Prix de la part :",
      "tenPercentAmount": "10 % de parts sans frais en dollars :",
      "backEndFeePercentage": "Pourcentage des frais de rachat :",
      "marketValue": "Valeur marchande :",
      "grossRedemption": "Rachat brut :",
      "backEndRedemptionFee": "Frais de rachat :",
      "grossProceeds": "Produit brut :",
      "withholdingTax": "Retenue d'impôt :",
      "netAmount": "Montant net :"
    },
    "redeem": "Racheter",
    "selectFund": "Sélectionner le fonds",
    "amountType": "Type de montant",
    "selectAccount": "Sélectionner le compte",
    "fund": "Fonds",
    "removeFund": "Retirer le fonds",
    "addFund": "Ajouter un fonds",
    "calculate": "Calculer",
    "clear": "Effacer",
    "download": "Télécharger le PDF",
    "error": "Impossible de calculer le rachat. Veuillez réessayer.",
    "noSecuritiesToRedeem": "Ce compte n'a aucun titre à racheter.",
    "redeemModes": {
      "single": "Un seul fonds",
      "multiple": "Fonds multiples",
      "entire": "Tout le compte"
    },
    "amountTypes": {
      "allShares": "100 % actions",
      "shares": "Titres/parts",
      "dollarAmount": "Dollars – brut",
      "dollarNetAmount": "Dollar – net",
      "annualFreeAllocation": "Montant annuel sans frais (10 % sans frais)",
      "dscFree": "Sans FAR (parts échues et 10 % sans frais)"
    },
    "errors": {
      "dollarExceed": "Le montant dépasse la valeur de retrait.",
      "sharesExceed": "Le montant dépasse la quantité détenue."
    },
    "pdfPreview": {
      "title": "Télécharger le PDF",
      "fileName": "Nom du fichier",
      "save": "Enregistrer le PDF",
      "cancel": "Annuler",
      "generateError": "Impossible de générer l'aperçu PDF. Veuillez réessayer.",
      "saveError": "Impossible d'enregistrer le PDF. Veuillez réessayer."
    },
    "title": "Calculatrice de rachat"
  },
  "signFormCompletions": {
    "resendForSignature": "Renvoyer pour signature",
    "resendConfirmTitle": "Renvoyer pour signature?",
    "resendConfirmBody": "Cela enverra une nouvelle notification de signature aux signataires n'ayant pas terminé. Tout progrès de signature sur ce lot sera conservé.",
    "resendSuccess": "Lot de formulaires renvoyé pour signature.",
    "resendError": "Impossible de renvoyer le lot de formulaires. Essayez de regénérer les formulaires si le problème persiste."
  }
}
